module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Farligt gods / ADR"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer ilt og gas, fyrværkeri, cellulosefortynder, silikonefjerner, acetone,"), _c('br'), _vm._v("malerrelaterede varer samt spild etc.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn er certificeret til at håndtere farligt gods (ADR)\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/pp_farligtgods_certifikat.png",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Energistyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "src": "/static/images/farligt_gods.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/farligt_gods_2.jpg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42821a2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products/farligtgods.vue
// module id = 262
// module chunks = 1